import { createFileRoute, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { hasModule, firstAllowedRoute } from "@/lib/auth";
import { Skeleton } from "@/components/feedback/Skeleton";
import { PalletAccountCard } from "@/features/palletAccounts/PalletAccountCard";
import { getAccount, palletAccountKeys } from "@/features/palletAccounts/palletAccounts.api";

// One relation on the pallet account (docs/scantafel.md §5): its balances, agreement and mutations.
export const Route = createFileRoute("/_shell/pallet-accounts/$partyId")({
  beforeLoad: ({ context }) => {
    if (!hasModule(context.session, "tms_orders") && !hasModule(context.session, "tms_orders_write") && !hasModule(context.session, "pallet_accounts_write")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  component: PalletAccountScreen,
});

function PalletAccountScreen() {
  const { t } = useTranslation();
  const { partyId } = Route.useParams();
  const { session } = Route.useRouteContext();
  const query = useQuery({ queryKey: palletAccountKeys.detail(partyId), queryFn: () => getAccount(partyId), retry: false });
  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office Pallet Account">
      {query.isPending ? (
        <Skeleton height="var(--space-24)" />
      ) : query.isError || !query.data ? (
        <p className="t-body t-muted">{t("palletAccounts.notFound")}</p>
      ) : (
        <PalletAccountCard account={query.data} userId={session.userId} canWrite={hasModule(session, "pallet_accounts_write")} />
      )}
    </div>
  );
}
